export default {
      id: "unit_dashboard__check_null-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__check_null",
      toString: function () {
        return this.url;
      }
    }